/* jshint -W097 */
/* jshint -W117 */

'use strict'
import axios from 'axios'
import Qs from 'qs'
import Cookies from '../http/cookie'
import router from '../router/index'
axios.defaults.baseURL = '/'

/**
 * Axios请求拦截器
//  */
axios.interceptors.request.use(config => {
  const token = Cookies.get('token')
  if (token) {
    config.headers.Authorization = token
  }
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Cookies.del('token')
          // 这里写清除token的代码
          router.replace({
            path: '/signin',
            query: {
              redirect: router.currentRoute.fullPath
            } // 登录成功后跳入浏览的当前页面
          })
      }
    }
    return Promise.reject(error.response.data)
  })

/**
 * 【单一请求】检查http状态码
 * @param {object} response -- 异步请求返回的数据对象
 * @return {object}  请求正常则返回数据对象data，否则返回自定义错误提示信息对象
 */
function checkStatus (response) {
  // 如果http状态码正常，则直接返回数据 暂时不考虑304 400的情况
  if (response.status === 200) {
    // 这里不需要除了data之外的数据，所以直接 return response.data
    return {
      status: 200,
      data: response.data
    }
  }
  return {
    status: -400,
    msg: '请确认您的网络连接正常，然后点击刷新重试'
  }
}

/**
 * 【单一请求】检查异步请求的后端返回信息码code
 * @param {object} res -- 异步请求返回的数据主体对象
 * @return {object}  code正常则返回数据对象数据主体对象，否则弹出对话框显示msg信息
 */
function checkCode (res) {
  if (res.status === -400) {
    // iView.Modal.error({
    //     title: '温馨提示',
    //     width: 500,
    //     content: res.msg
    // });
    alert(res.msg)
    return false
  }
  // 如果code异常，可以弹出一个错误提示，告诉用户
  if (res.data.code === 200) {
    return res.data
  } else {
    // iView.Modal.error({
    //     title: '温馨提示',
    //     width: 500,
    //     content: res.data.msg
    // });
    return false
  }
}

/**
 * 【并发请求】检查http状态码
 * @param {array} resList
 * @return {object}
 */
function checkAllStatus (resList) {
  let isSuccess = resList.every(item => {
    return item.status === 200
  })
  if (isSuccess) {
    let dataList = resList.map(item => {
      return item.data
    })
    return {
      status: 200,
      data: dataList
    }
  } else {
    return {
      status: -400,
      msg: '请确认您的网络连接正常，然后点击刷新重试'
    }
  }
}

/**
 * 【并发请求】检查异步请求的后端返回信息码code
 * @param {object} resObj
 * @return {object/array}
 */
function checkAllCode (resObj) {
  if (resObj.status === -400) {
    alert(resObj.msg)
    return false
  }
  let isSuccess = resObj.data.every(item => {
    return item.code === 200
  })
  if (isSuccess) {
    let dataList = resObj.data.map(item => {
      return item.data
    })
    return dataList
  } else {
    alert('当前服务不可用，请手动刷新后重试')
    return false
  }
}

/*
 * 获取token，为所有url添加token，无论哪一种请求
 */

// let token = JSON.parse(sessionStorage.getItem('token'));
// console.log(token);
/*
 * Axios封装-get/post/put/delete/all
 */
export default {
  get (url, params) {
    let token = Cookies.get('token')
    params = Object.assign({}, params, {
      'access_token': token
    })

    return axios({
      method: 'get',
      url,
      params,
      timeout: 25000
    })
      .then(checkStatus)
      .then(checkCode)
  },
  post (url, urlParams, bodyParams) {
    let token = Cookies.get('token')
    urlParams = Object.assign({}, urlParams, {
      'access_token': token
    })
    url += '?' + Qs.stringify(urlParams)
    return axios({
      method: 'post',
      url,
      data: JSON.stringify(bodyParams),
      timeout: 25000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(checkStatus)
      .then(checkCode)
  },
  put (url, urlParams, bodyParams) {
    let token = Cookies.get('token')
    urlParams = Object.assign({}, urlParams, {
      'access_token': token
    })
    url += '?' + Qs.stringify(urlParams)
    return axios({
      method: 'put',
      url,
      data: JSON.stringify(bodyParams),
      timeout: 25000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(checkStatus)
      .then(checkCode)
  },
  delete (url, urlParams, bodyParams) {
    let token = Cookies.get('token')
    urlParams = Object.assign({}, urlParams, {
      'access_token': token
    })
    url += '?' + Qs.stringify(urlParams)
    return axios({
      method: 'delete',
      url,
      data: JSON.stringify(bodyParams),
      timeout: 25000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(checkStatus)
      .then(checkCode)
  },
  all (requestList) {
    requestList = requestList.map(item => {
      let queryParams = null
      let urlParams = null
      let token = Cookies.get('token')
      // 设置get请求的token
      if (item.queryParams) {
        queryParams = Object.assign({}, {
          'access_token': token
        }, item.queryParams)
      } else {
        queryParams = {
          'access_token': token
        }
      }

      // 设置post请求的token
      if (item.urlParams) {
        urlParams = Object.assign({}, {
          'access_token': token
        }, item.urlParams)
      } else {
        urlParams = {
          'access_token': token
        }
      }

      // 发出请求
      if (item.type === 'get') {
        item.url += '?' + Qs.stringify(queryParams)
        return axios.get(item.url)
      }
      if (item.type === 'post') {
        item.url += '?' + Qs.stringify(urlParams)
        return axios.post(item.url, item.bodyParams, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
      }
    })
    return axios.all(requestList)
      .then(axios.spread((...resList) => {
        return checkAllStatus(resList)
      }))
      .then(resObj => {
        return checkAllCode(resObj)
      })
  }
}



// WEBPACK FOOTER //
// ./src/http/http.js